export default __webpack_public_path__ + "static/media/exterior1.2b17b677.jpg";